import { ChatMessage } from '../entity';

export class ChatMessageSentEvent {
  constructor(
    public message: ChatMessage,
    public edit = false,
  ) {}
}
